import React, { useState, useEffect } from "react";
import { Col, Container, Row, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";

const Projects = () => {
  const navigate = useNavigate();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [projects, setProjects] = useState([
    {
      id: "Dou",
      icon: "mdi-account-group-outline",
      route: "dou",
      title:
        "What if YOU could make money from social media without being a influencer?",
      description:
        "Get, Dou, the social media app that shares its ad revenue with you. The first to sign up gets the most dough.",
    },
    {
      id: "GoodWithMoney",
      icon: "mdi-currency-usd",
      route: "goodwithmoney",
      title: "Tired of your paychecks disappearing too fast?",
      description: `Whether you need a weekly or monthly budget plan, I’ll
                        create a personalized strategy that works for YOU. The
                        first week is free!`,
    },
    {
      id: "Small Ties",
      icon: "mdi-shopping",
      route: "smallties",
      title: "Shop Where Your Dollars Make a Difference.",
      description:
        "Your everyday needs, delivered exclusively by small businesses.",
    },
  ]);

  return (
    <React.Fragment>
      <section className="section bg-benefits" id="benefits">
        <Container>
          <Row>
            <Col lg="12">
              <div className="title-box text-center">
                <h3 className="title-heading mt-4">Lost? Let us help! </h3>
                <p className="text-muted f-17 mt-3">
                  Small Ties has several programs. Our mission is to build
                  happier communities online and in real life. Click to select
                  the waitlist that you wish to join.
                </p>
              </div>
            </Col>
          </Row>
          <Row className="mt-5 pt-4">
            {projects.map((item) => (
              <Col lg={4} key={item.id}>
                <Button
                  outline
                  className="benefits-box p-4 mt-4 "
                  onMouseOver={() => setHoveredItem(item.id)}
                  onMouseOut={() => setHoveredItem(null)}
                  onClick={() => navigate(item.route)}
                >
                  <div className="benefits-icon bg-soft-primary">
                    <i className={`mdi text-primary ${item.icon}`}></i>
                  </div>
                  <h5 className="mt-4">{item.title}</h5>
                  <p className="text-muted mt-3">{item.description}</p>
                </Button>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Projects;
